import { oidcEarlyInit } from 'oidc-spa/entrypoint';
import { browserRuntimeFreeze } from 'oidc-spa/browser-runtime-freeze';
import { initMonitoring } from './monitoring';

// Initialize error monitoring before anything else.
// Safe to call here — Sentry.init() only registers listeners, no network I/O.
initMonitoring();

const { shouldLoadApp } = oidcEarlyInit({
  securityDefenses: {
    ...browserRuntimeFreeze(),
  },
  BASE_URL: '/', // The path where your app is hosted
});

if (shouldLoadApp) {
  // Note: Deferring the main app import adds a few milliseconds to cold start,
  // but dramatically speeds up auth. Overall, it's a net win.
  import('./main.lazy');
}

